<script>
import { useI18n } from "vue-i18n";

export default {
  props: {
    errorTitle: {
      type: String,
      default: "Oh Snap!",
      required: false
    },
    errorMessage: {
      type: String,
      default: null,
      required: false
    },
    pageTitle: {
      type: String,
      default: "AllGive",
      required: false
    }
  },
  setup(props) {
    if (props.pageTitle) {
      document.title = props.pageTitle;
    }
    const { t } = useI18n();
    const message = props.errorMessage ?? t("generic_errors.not_found");
    return { t, message };
  }
};
</script>

<template>
  <div class="page-wrapper">
    <div class="container">
      <!-- Message Section -->
      <div class="message">
        <h1>{{ errorTitle }}</h1>
        <p>{{ message }}</p>
        <a href="/">Take Me Home</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #FFF;
  font-family: Arial, sans-serif;
  padding: 0 20px;
  text-align: center;
}

/* Container styling */
.container {
  max-width: 600px;
  margin: 0 auto;
}

/* Message styling */
.message h1 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 20px;
}

.message p {
  font-size: 1rem;
  color: #8c8c8c;
  margin-bottom: 20px;
}

.message a {
  text-decoration: none;
  padding: 10px 20px;
  background-color: rgb(16, 190, 90);
  color: #FFF;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: inline-block;
}

.message a:hover {
  background-color: rgb(8, 96, 45);
}
</style>
